import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { OFFER_CARD_EDIT, OFFER_CARD_TABS } from '../../../../constants/OfferConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_OFFERS,
} from '../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { offerCardsSelector } from '../../cmsSlice';
import OfferCardDetails from './Offer-Card-Details';

const OfferCardView = (props) => {
  const { offer, toggleDrawer, onViewToggle, permissions } = props;
  const cmsOffer = useSelector(offerCardsSelector);
  const [tabValue, setTabValue] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(offer);

  useEffect(() => {
    if (cmsOffer.length) {
      const currOffer = cmsOffer.find((o) => o.id === offer.id);
      setSelectedOffer(currOffer);
    }
  }, [cmsOffer, offer.id]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, selectedOffer);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(OFFER_CARD_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <OfferCardDetails tabValue={tabValue} offer={selectedOffer} />;
  };

  return (
    <>
      {selectedOffer && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={OFFER_CARD_TABS}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={selectedOffer.createdBy}
          isEditable={permissions[RBAC_TYPE_CMS_OFFERS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          isHeightIncluded={true}
          title={selectedOffer?.offerCardName}
          tabClass='col-md-10'
        />
      )}
    </>
  );
};

export default OfferCardView;
